import React from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import AdminIcon from "./adminIcons";
import { ADMIN_COLORS } from "./adminUi";
import { RECORD_TYPE } from "./AdminRecordParts";

/** Full width on phones, fixed panel from tablets up. */
export var ADMIN_DRAWER_WIDTH = { xs: "100%", sm: 560 };

/** Figma keeps the description to a 320px column (two lines). */
var DESCRIPTION_MAX_WIDTH = 320;

var EDGE_PADDING = { xs: "16px", sm: "24px" };

/**
 * Right-side "View" drawer shared by Manage New Joinee and Manage HR:
 * title + subtitle + close, scrollable body, optional pinned footer.
 */
function AdminDrawer(props) {
  return (
    <Drawer
      anchor="right"
      open={props.open}
      onClose={props.onClose}
      BackdropProps={{ sx: { bgcolor: "rgba(0, 0, 0, 0.28)" } }}
      PaperProps={{
        sx: {
          width: ADMIN_DRAWER_WIDTH,
          maxWidth: "100vw",
          bgcolor: ADMIN_COLORS.card,
          borderLeft: "1px solid " + ADMIN_COLORS.line,
          boxShadow: "-4px 0 8px rgba(23, 26, 28, 0.1)",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        },
      }}
    >
      <Box sx={{ px: EDGE_PADDING, pt: "20px", flexShrink: 0 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            gap: "16px",
            pb: "16px",
            borderBottom: "1px solid " + ADMIN_COLORS.lineSoft,
          }}
        >
          <Box sx={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column", gap: "4px" }}>
            <Typography component="h2" sx={Object.assign({ color: ADMIN_COLORS.label }, RECORD_TYPE.title)}>
              {props.title}
            </Typography>
            {props.subtitle ? (
              <Typography
                sx={Object.assign({ color: ADMIN_COLORS.labelSecondary, maxWidth: DESCRIPTION_MAX_WIDTH }, RECORD_TYPE.description)}
              >
                {props.subtitle}
              </Typography>
            ) : null}
          </Box>
          <IconButton aria-label="Close" onClick={props.onClose} sx={{ p: "6px", mt: "-2px", color: "#091E42" }}>
            <AdminIcon name="X" size={24} />
          </IconButton>
        </Box>
      </Box>

      <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto", px: EDGE_PADDING, pt: "20px", pb: "24px" }}>
        {props.loading ? (
          <Box sx={{ py: 10, textAlign: "center" }}>
            <CircularProgress size={30} sx={{ color: ADMIN_COLORS.brand }} />
          </Box>
        ) : (
          props.children
        )}
      </Box>

      {props.footer ? (
        <Box sx={{ px: EDGE_PADDING, pb: "20px", flexShrink: 0, bgcolor: ADMIN_COLORS.card }}>{props.footer}</Box>
      ) : null}
    </Drawer>
  );
}

export default AdminDrawer;
